import React from "react";
import EditInvoice from "./EditInvoice";
import { resolveSaleIsQuote } from "../utils/salesErpAdapter";

/**
 * View-only sales bill UI (same layout as Edit Invoice).
 * Used from Sales Ledger / Customer Ledger popups — loads only POST /sales (type: show).
 * In quote PIN + "All", routes SAL → /api and QSAL → /quote via isQuote.
 */
export default function ViewSalesInvoice({
  saleId,
  selectedItemIds,
  selectedInvoices,
  onClose,
  masterGoldRate,
  masterSilverRate,
  showLiveRate = false,
  isQuote,
}) {
  const resolvedIsQuote =
    isQuote !== undefined && isQuote !== null
      ? Boolean(isQuote)
      : resolveSaleIsQuote(selectedInvoices?.[0]);

  return (
    <EditInvoice
      saleId={saleId}
      selectedItemIds={selectedItemIds}
      selectedInvoices={selectedInvoices}
      onClose={onClose}
      masterGoldRate={masterGoldRate}
      masterSilverRate={masterSilverRate}
      showLiveRate={showLiveRate}
      isQuote={resolvedIsQuote}
      viewOnly
    />
  );
}
